import { AsyncPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, input } from '@angular/core';

import { FontIconComponent } from '@camelot/icons';
import { CamContactService } from '@camelot/services';
import { ButtonComponent, ErrorComponent, LoaderComponent } from '@camelot/ui';
import { CamBaseComponent, openExternalUrl } from '@camelot/utils';

@Component({
  selector: 'cam-tenant-url-displayer',
  templateUrl: './tenant-url-displayer.component.html',
  styleUrls: ['./tenant-url-displayer.component.scss'],
  imports: [AsyncPipe, ButtonComponent, FontIconComponent, LoaderComponent, ErrorComponent],
})
export class TenantUrlDisplayerComponent extends CamBaseComponent {
  contactId = input.required<string>();

  display = input<'button' | 'icon'>('icon');

  get contactTenantRoute$() {
    return this._contactService.contactTenantRoute.get$();
  }

  private _contactService = inject(CamContactService);

  ngOnInit() {
    this._fetch();
  }

  public navigateToTenantContact(url: string) {
    openExternalUrl(url);
  }

  private _fetch() {
    this.requestState.asked();
    this._contactService.fetchContactTenantRoute$(this.contactId()).subscribe({
      next: () => {
        this.requestState.completed();
      },
      error: (error: HttpErrorResponse) => {
        this.requestState.onError(error.status, error.statusText);
      },
    });
  }
}
